"use client";

import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ArrowRight } from "lucide-react";
import { SectionContainer } from "@/components/ui/container";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function CTASection() {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <SectionContainer className="relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <motion.div
          className="absolute -top-16 -left-16 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1 }}
        />
        <motion.div
          className="absolute top-1/2 -right-32 w-64 h-64 bg-blue-600/10 rounded-full blur-3xl"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        />
        <motion.div
          className="absolute -bottom-8 left-1/3 w-40 h-40 bg-blue-300/10 rounded-full blur-3xl"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        />
      </div>

      <div 
        ref={ref}
        className="bg-gradient-to-r from-blue-700 to-blue-500 rounded-3xl py-16 px-6 md:py-20 md:px-12 relative z-10"
      >
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2
            className="text-3xl md:text-4xl font-heading font-bold text-white mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6 }}
          >
            Ready to Support Blue Legos?
          </motion.h2>
          <motion.p
            className="text-lg md:text-xl text-blue-50 mb-10"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Join thousands of supporters advocating for blue brick equality. 
            Every contribution helps ensure that blue Legos get the recognition and appreciation they deserve.
          </motion.p>
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Button
              size="lg"
              variant="secondary" 
              className="text-blue-800 font-semibold text-base"
              isAnimated
            >
              Donate Now <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              size="lg"
              variant="gradient-outline" 
              className="text-white font-semibold text-base"
              isAnimated
            >
              Become a Volunteer
            </Button>
          </motion.div>
        </div>
      </div>
    </SectionContainer>
  );
}